<template>
  <div class="wrapper">
    <v-head></v-head>
    <v-menu></v-menu>
    <div class="content">
      <transition name="move" mode="out-in">
        <!-- <keep-alive>
          <router-view></router-view>
        </keep-alive> -->
        <keep-alive v-if="$route.meta.keepAlive">
          <router-view  @fnTabName="fnTabName"></router-view>
        </keep-alive>
        <router-view v-else @fnTabName="fnTabName"></router-view>
      </transition>
    </div>
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from "@/components/common/Header";
import vMenu from "@/components/common/menu";
import vFooter from "@/components/common/Footer";
export default {
  data: function() {
    return {
      tabName: '',
    };
  },
  components: {
    vHead,vMenu,vFooter
  },
  created() {},
  mounted() {
  },
  watch: {
      '$route'(to,from) {
          this.tabName = '';
      }
  },
  methods: {
    fnTabName(tabName='') {
        this.tabName = tabName;
    },
  }
};
</script>

<style scoped>
</style>